import { LoadingButton } from "@mui/lab";
import { Box, Button, Rating, Stack, Typography } from "@mui/material";
import { useState } from "react";
import { toast } from "react-toastify";
import axios from "../../config/axios";
import { useMutation } from "@tanstack/react-query";
import { useParams } from "react-router-dom";

const rateVideo = async ({ rating, feedback, videoId }) => {
  return axios.post(`reviews/${videoId}`, { rate: rating, feedback });
};
export default function RatingDialog({ handleClose }) {
  const [rating, setRating] = useState(0);
  const [feedback, setFeedback] = useState("");
  const { vidId } = useParams();

  const { mutate, isLoading } = useMutation({
    mutationFn: rateVideo,
    onSuccess: () => {
      toast.success(".شكرًا لتقييمك! نحن نقدر ملاحظاتك");
      handleClose();
    },
    onError: () => {
      toast.error("عذرًا، حدث خطأ غير متوقع. يرجى المحاولة مرة أخرى.");
    },
  });

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (rating >= 1) mutate({ rating, feedback, videoId: vidId });
    else toast.warn("يرجى إدخال تقييم لإكمال العملية");
  };

  return (
    <Stack component="form" alignItems="center" gap={2} onSubmit={handleSubmit}>
      <Typography textAlign="center" variant="h5" fontWeight={400}>
        شاركنا رأيك حول هذا الفيديو. تقيمك يساعدنا على التحسن!
      </Typography>
      <Rating
        size="large"
        value={rating}
        onChange={(e, newValue) => {
          setRating(newValue);
        }}
      />
      <Typography
        mt={3}
        mb={-1.5}
        variant="body2"
        fontWeight={300}
        alignSelf="flex-start"
      >
        أخبرنا بما أعجبك أو كيف يمكننا التحسن!
      </Typography>
      <Box
        component="textarea"
        value={feedback}
        onChange={(e) => setFeedback(e.target.value)}
        sx={{
          width: "100%",
          fontFamily: "zain",
          fontSize: 16,
          boxSizing: "border-box",
        }}
        px={1}
        py={1.25}
        borderRadius={1}
        rows={3}
        dir="auto"
      />

      <Stack flexDirection="row" alignSelf="flex-start" gap={0.5} mt={3}>
        <LoadingButton
          loading={isLoading}
          variant="contained"
          size="small"
          type="submit"
        >
          ارسال
        </LoadingButton>
        <Button
          onClick={handleClose}
          variant="contained"
          color="lightgrey"
          size="small"
        >
          الغاء
        </Button>
      </Stack>
    </Stack>
  );
}
